import React from "react";
import { Button, Col, Row } from "reactstrap";

const DraftButtons = ({
  handleSaveDraft,
  status,
  resetForm,
  formik,
  handleGenerate,
}) => {
  return (
    <>
      {status === "Submitted" && (
        <Row className="">
          <Col lg={6}>
            <Row>
              <Col lg={4} className="d-flex ">
                <Button
                  block
                  outline
                  size="lg"
                  color="primary"
                  className="btn  p-2 w-100 ms-1"
                  onClick={handleGenerate}
                >
                  Save as PDF
                </Button>
              </Col>
            </Row>
          </Col>

          <Col lg={6}>
            <Row>
              <div className="d-flex justify-content-end">
                <div
                  className="btn p-2 wave-effect w-80 ms-4 fs-18"
                  style={{ height: "100%", color: "green" }}
                >
                  Waiting for acknowledgement
                </div>
              </div>
            </Row>
          </Col>
        </Row>
      )}
      {status === "Draft" && (
        <Row>
          <Col lg={6}>
            <Row>
              <Col lg={4}>
                <Button
                  type="button"
                  outline
                  size="lg"
                  className="ms-auto p-2 border-primary"
                  color="primary"
                  style={{ width: "100%" }}
                >
                  Delete
                </Button>
              </Col>
              <Col lg={4} className="d-flex ">
                <Button
                  type="button"
                  outline
                  size="lg"
                  className="ms-auto p-2 border-primary"
                  color="primary"
                  style={{ width: "100%" }}
                  onClick={() => {
                    // Clear form fields
                    formik.setFieldValue("reportTxns", "");
                    formik.setFieldValue("reportTypeId", "");
                    formik.setFieldValue("reportName", "");
                    formik.setFieldValue("name", "");
                    formik.setFieldValue("year", "");
                    formik.setFieldValue("month", "");

                    // Call handleSaveDraft after clearing
                    // handleSaveDraft();
                  }}
                >
                  Clear Data
                </Button>
              </Col>
              <Col lg={4} className="d-flex ">
                <Button
                  type="button"
                  outline
                  size="lg"
                  className="ms-auto p-2 border-primary"
                  color="primary"
                  style={{ width: "100%" }}
                  onClick={handleGenerate}
                >
                  Save as PDF
                </Button>
              </Col>
            </Row>
          </Col>

          <Col lg={6}>
            <Row>
              <div className="d-flex justify-content-end gap-4">
                <Button
                  type="button"
                  size="lg"
                  className="ms-auto p-2 border-white"
                  color="danger"
                  onClick={handleSaveDraft}
                  style={{ width: "30%" }}
                >
                  Save as Draft
                </Button>

                <Button
                  type="submit"
                  size="lg"
                  color="info"
                  className="btn p-2"
                  style={{ width: "30%", marginRight: "-5px" }}
                >
                  Submit
                </Button>
              </div>
            </Row>
          </Col>
        </Row>
      )}
    </>
  );
};

export default DraftButtons;

// import React, { useState } from "react";
// import { Button, Col, Row } from "reactstrap";
// import ModalReport from "../Modal/modal";

// const DraftButtons = ({ handleInitiateReport, handleSaveDraft, status }) => {
//   const [isModalOpen, setModalOpen] = useState(false);
//   const [selectedOptions, setSelectedOptions] = useState([]);

//   const toggleModal = () => setModalOpen(!isModalOpen);

//   const openModal = () => {
//     // Add any logic needed before opening the modal
//     setModalOpen(true);
//   };

//   const handleSubmit = () => {
//     // Add your submit logic here
//     console.log("Form submitted with selected options:", selectedOptions);
//     setModalOpen(false); // Close the modal after submission
//   };

//   return (
//     <>
//       {status === "Submitted" && (
//         <Row>
//           <Col lg={6}>
//             <Row>
//               <Col lg={4} className="d-flex">
//                 <Button
//                   block
//                   outline
//                   size="lg"
//                   color="primary"
//                   className="btn p-2 w-100 ms-1"
//                 >
//                   Save as PDF
//                 </Button>
//               </Col>
//             </Row>
//           </Col>

//           <Col lg={6}>
//             <Row>
//               <div className="d-flex justify-content-end">
//                 <div
//                   className="btn p-2 wave-effect w-80 ms-4 fs-18"
//                   style={{ height: "100%", color: "green" }}
//                 >
//                   Waiting for acknowledgement
//                 </div>
//               </div>
//             </Row>
//           </Col>
//         </Row>
//       )}
//       {status === "Draft" && (
//         <Row>
//           <Col lg={6}>
//             <Row>
//               <Col lg={4}>
//                 <Button
//                   outline
//                   size="lg"
//                   className="ms-auto p-2 border-primary"
//                   color="primary"
//                   style={{ width: "100%" }}
//                 >
//                   Delete
//                 </Button>
//               </Col>
//               <Col lg={4} className="d-flex">
//                 <Button
//                   outline
//                   size="lg"
//                   className="ms-auto p-2 border-primary"
//                   color="primary"
//                   style={{ width: "100%" }}
//                 >
//                   Clear Data
//                 </Button>
//               </Col>
//               <Col lg={4} className="d-flex">
//                 <Button
//                   outline
//                   size="lg"
//                   className="ms-auto p-2 border-primary"
//                   color="primary"
//                   style={{ width: "100%" }}
//                 >
//                   Save as PDF
//                 </Button>
//               </Col>
//             </Row>
//           </Col>

//           <Col lg={6}>
//             <Row>
//               <div className="d-flex justify-content-end gap-4">
//                 <Button
//                   size="lg"
//                   className="ms-auto p-2 border-white"
//                   color="danger"
//                   onClick={handleSaveDraft}
//                   style={{ width: "30%" }}
//                 >
//                   Save as Draft
//                 </Button>

//                 <Button
//                   size="lg"
//                   color="info"
//                   className="btn p-2"
//                   onClick={openModal}
//                   style={{ width: "30%" }}
//                 >
//                   Submit
//                 </Button>
//               </div>
//             </Row>
//           </Col>
//         </Row>
//       )}
//       <ModalReport
//         isModalOpen={isModalOpen}
//         toggleModal={toggleModal}
//         handleSubmit={handleSubmit}
//         setSelectedOptions={setSelectedOptions}
//         handleSaveDraft={handleSaveDraft}
//         status={status}
//       />
//     </>
//   );
// };

// export default DraftButtons;
